export enum EdgeReinforcementType {
  None = 'none',
  StraightEdge = 'straight_edge',
  StraightEdgeWithStirrups = 'straight_edge_with_stirrups',
}
